import ProductDescription from './ProductDescription'

const DriedFruitsProduct = {
  ...ProductDescription,
  category: '19',
  subCategory: '004',
  IsBroadband: true,
  DFType: '',
  DFPackageType: '',
  DFSize: '',
  Organic: false,
  NoAdditionalIngredients: false,
  otherType: '',
  otherPackageType: '',
}

export default DriedFruitsProduct
